import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const momentumTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.momentum,
  logoUrl: "https://cdn.nemuru.com/assets/logos/bmwmomentum-logo.png",
  palette: {
    primary: {
      main: "#1c69d4",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#a6a6a6",
      contrastText: "#000",
    },
    warning: {
      main: "#d87b26",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    text: {
      title: "#1c69d4",
      primary: "#444",
      secondary: "#666",
    },
    info: {
      main: "#0041a5",
      contrastText: "#fff",
      light: "#cce0ff",
    },
    success: {
      main: "#519f4c",
      contrastText: "#ffffff",
      light: "#6df39e96",
    },
    error: {
      main: "#dc0723",
      contrastText: "#ffffff",
      light: "#ff8e9c",
    },
    // additional colors
    dark: {
      main: "#0041a5",
      accent: "#1e3555",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#2ea3f2",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.FILLED,
  background: "#fff",
  customBorderRadius: {
    button: 2,
    paper: 0,
    chip: 100,
  },
};
